module.exports = __webpack_public_path__ + "media/images/emblems/Canobbio-coat_of_arms-f3d5dbd5d258d28338acf01d6f370747.svg";